import type { ReactNode } from "react";
import styles from "./styles.module.scss";

interface IResponsiveWrapProps {
  children: ReactNode;
  maxWidth?: number | string;
  className?: string;
  id?: string;
}

const ResponsiveWrap = ({
  className = "",
  children,
  maxWidth = 900,
  id,
}: IResponsiveWrapProps) => {
  return (
    <div
      id={id}
      className={`${className} ${styles.container} pr`}
      style={{ maxWidth }}
    >
      {children}
    </div>
  );
};

export default ResponsiveWrap;
